module.exports = __webpack_public_path__ + "0b6cc88bf6166d6100f5d42037f13699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio4/open_my_glade_holder.jpg
// module id = 895
// module chunks = 0